import { useState } from "react";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { api, errText } from "@/lib/api";

export const ChangePasswordForm = ({ onDone, forced }) => {
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < 8) return setErr("New password must be at least 8 characters");
    if (f.next !== f.confirm) return setErr("Passwords do not match");
    setBusy(true);
    setErr("");
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password changed");
      onDone();
    } catch (x) { setErr(errText(x)); }
    setBusy(false);
  };

  const F = ({ k, label, auto }) => (
    <div className="space-y-1.5">
      <Label className="text-xs text-slate-600">{label}</Label>
      <PasswordInput autoComplete={auto} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} required data-testid={`pw-${k}-input`} />
    </div>
  );
  return (
    <form onSubmit={submit} className="space-y-4" data-testid="change-password-form">
      {forced && <p className="rounded-md bg-amber-50 px-3 py-2 text-sm text-amber-800">Please set a new password before continuing.</p>}
      {F({ k: "current", label: forced ? "Temporary password" : "Current password", auto: "current-password" })}
      {F({ k: "next", label: "New password (min 8 characters)", auto: "new-password" })}
      {F({ k: "confirm", label: "Confirm new password", auto: "new-password" })}
      {err && <p className="text-sm text-red-600" data-testid="pw-error">{err}</p>}
      <Button type="submit" disabled={busy} className="w-full bg-plum-700 hover:bg-plum-800" data-testid="pw-submit-btn">
        {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <KeyRound className="mr-2 h-4 w-4" />}Update password
      </Button>
    </form>
  );
};
